import { render, staticRenderFns } from "./SpeedDialCorps.vue?vue&type=template&id=8f300e5e"
import script from "./SpeedDialCorps.vue?vue&type=script&lang=ts"
export * from "./SpeedDialCorps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports